import { languageService } from "../../../../Language/language.service";
import { arrayToSelectOptions } from "../../../../utils/arrayToSelectOptions";
import { isFraRole } from "../../../MainPage/UserInfo";

const dateFormat = "MM-DD-yy";

const FRADateLimit = new Date(new Date().setFullYear(new Date().getFullYear() - 2)).toISOString();

export const hosViolationSearchFiltersFormSchema = {
  title: languageService("Search HOS Records"),
  id: "hosViolationSearchFiltersFormSchema",
  returnOnlyEnabledFields: false,
  stateTitle: {
    draft: `${languageService("Search HOS Records")}*`,
    stable: languageService("Search HOS Records"),
  },
  sections: [
    {
      id: "dateAndTimeEntrySection",
      fields: [
        {
          id: "startDate",
          type: "date",
          labelValue: languageService("Start Date"),
          format: dateFormat,
          ...(isFraRole() && { minDate: FRADateLimit }),
          ...(!isFraRole() && { pastOnly: true }),
          col: 4,
        },
        {
          id: "endDate",
          type: "date",
          labelValue: languageService("End Date"),
          format: dateFormat,
          ...(isFraRole() && { minDate: FRADateLimit }),
          ...(!isFraRole() && { pastOnly: true }),
          col: 4,
        },
      ],
    },

    {
      id: "footerActionsSection",
      fields: [
        {
          id: "violationsSearchRecords",
          type: "button",
          labelValue: languageService("Search"),
          action: "submit",
          callback: "violationsSearchRecords",
          position: "footer",
          col: 12,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosViolationReport/schemas/hosViolationSearchFiltersFormSchema.js